import request from '../request'

export default {
  async getPlanificacionByDateRange(inicio, fin) {
    return request.post('/planificacion_medio/dateRange', {
      inicio,
      fin
    })
  },
  async addPlanificacion(data) {
    return request.post('/planificacion_medio', data)
  },
  async editPlanificacion(data) {
    return request.put('/planificacion_medio', data)
  },

  async deletePlanificacionById(idPlanificacion) {
    return request.delete(`/planificacion_medio/${idPlanificacion}`)
  }
}
